import { useEffect, useMemo } from 'react';
import { Form, Field } from 'react-final-form';
import { InputLabel, MenuItem, Select, FormControl } from '@mui/material';
import { useTranslation } from 'core/contexts/localization';

const Item = ({ language, resources }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', }}>
    <img src={resources[language].image} width="16px" height="16px" alt={`${resources[language]}`} />
    <p>{language.toUpperCase()}</p>
    </div>
  );
};

const LanguageDropDown = ({collapsed = false}) => {
  const { i18n, t: translate } = useTranslation();

  const locales = useMemo(
    () => Object.keys(i18n.options.resources),
    [i18n.options.resources]
  );

  const handleChange = (input) => {
    i18n.changeLanguage(input);
  };

  useEffect(() => {
    try {
      window.localStorage.setItem('i18nextLng', i18n.language);
      
    } catch (e) {
      //ignore
    }
  }, [i18n.language]);

  return (
    <>
      <FormControl variant="outlined" fullWidth>
        {!collapsed && (
         <InputLabel id="select-language">
          {translate('layout.appBar.language')}
        </InputLabel>
        )}
        {!collapsed ? (
        <Select
          sx={{"& .MuiSelect-select":{ padding: '1.5px 14px !important'} }}
          labelId="select-language"
          id="select-language"
          label={translate('layout.appBar.language')}
          defaultValue={i18n.language}
          value={i18n.language}
          renderValue={(value) => (
            <Item language={value} resources={i18n.options.resources} />
          )}
          onChange={(e) => handleChange(e.target.value)}>
          {locales.map((value) => {
            return (
              <MenuItem
                key={`language-${value}`}
                style={{ color: 'black' }}
                value={value}>
                <Item language={value} resources={i18n.options.resources} />
              </MenuItem>
            );
          })}
        </Select>
        ) : 
        (<div> <img src={i18n.options.resources[i18n.language].image} width="16px" height="16px" alt={`${i18n.language}`}/> {i18n.language.toUpperCase()}</div>)}
      </FormControl>
    </>
  );
};


export default LanguageDropDown;
